import React, { useRef, useState }  from 'react'
// import from 'react'
import './loading.css'

function Loading() { 
const inn = useRef()
// const div = inn.current.value;
// console.log(div)
useState(() => {
    var per = 16;
    var loading = setInterval(animate, 100)
    function animate() { 
        if( per === 200 ) {
          clearInterval(loading)
        } else{
          per = per + 4;
          inn.current.style.width = per + 'px';
        } 
    }
  }, [])
  return (
    <>
      <div className='loading'>
      <div className='progress-bar'>
      <div className='progress' ref={inn}> </div>
      </div>
      </div> 
    </>
  )
}

export default Loading
